
let formatNumber = number => ("0" + number).slice(-2);

function dateToString(date, includeTime = true) {
    let day = formatNumber(date.getDate());
    let month = formatNumber(date.getMonth() + 1);
    let year = date.getFullYear();

    let hours = formatNumber(date.getHours());
    let minutes = formatNumber(date.getMinutes());

    const dateString = `${day}.${month}.${year}`
    const timeString = `${hours}:${minutes}`
    
    return includeTime ? `${dateString}, ${timeString}` : dateString;
}

module.exports = dateToString;